<div
  class="ml-2 flex w-max rounded-t-lg bg-blue pl-2 pr-4 text-center text-white"
>
  @if (icon) {
    <mat-icon
      role="img"
      class="!inline-flex items-center justify-center text-sm"
    >
      {{ icon }}
    </mat-icon>
  }
  <span class="self-center text-sm font-medium">
    {{ text }}
  </span>
</div>
